import React, { useEffect, useRef, useState } from 'react'
import ViewPage from '../../../Components/ViewPage'
import { ItensPerUserLogged } from '../../../services/login/permissaoUsuarioLoado'
import { TitleH1 } from '../../../Components/CustomUi/titleH1'
import { getPropriedade } from '../../../services/Propriedades'
import {
  delTalhao,
  getKmlTalhao,
  getTalhao,
  postTalhao,
  putTalhao,
  TalhaoItens,
} from '../../../services/Talhao'
import { formatarValor } from '../../../utils'
import { Drawer, Modal } from 'antd'
import { NavegacaoDrawer } from '../recomendacao/novoCompatibilidadeAtivo/components/gavetaCadastrar/styled'
import ButtonCustom from '../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFloppyDisk, faXmark } from '@fortawesome/free-solid-svg-icons'
import {
  destroyAlert,
  errorAlert,
  loadingAlert,
  successAlert,
  warningAlert,
} from '../../../utils/alert'
import { centerMap, fileTypeText, parseXml } from '../../../services/Afins'
import ImporteKmlTalhao from '../../../Components/importKmlTalhao'
import { UploadChangeParam } from 'antd/lib/upload'
import { kml } from '@tmcw/togeojson'
import DesenhaTalhao from '../../../Components/desenhoTalhao'
import { TabelaTalhoesPropriedade } from './components/tabela'
import { ContainerTalhao } from './styled'
import { useLogic } from '../../../context/useLogic'
import { useHistory } from 'react-router'
import DesenhaTalhaoNovo from './components/desenhoTalhaoNovo/new'
import FormTalhaoNovo from './components/formTalhao'

interface TypeEditPolygon {
  nome: string
  propriedadeCod: number
  propriedadeNome: string
  fitBounds: google.maps.LatLngBounds | google.maps.LatLngBoundsLiteral
  polygon: google.maps.LatLngLiteral[] | google.maps.LatLng[]
}

export interface TypesMapa {
  zoom: number
  center:
    | {
        lat: number
        lng: number
      }
    | google.maps.LatLng
  mapContainerStyle?: { [key: string]: string }
}

interface TypeDataTalhao {
  alert?: boolean
  talhao: string
  ativo: boolean
  coord:
    | {
        lat: number
        lng: number
      }[]
    | google.maps.LatLng
}

const TalhaoNovo: React.FC = () => {
  const url = useRef(null)
   const { checkSafra } = useLogic()
     const history = useHistory()
  const [permissions, setPermissions] = useState<ItensPerUserLogged>()
  const [dataTalhao, setDataTalhao] = useState([])
  const [dataPropriedade, setDataPropriedade] = useState([])
  const [loadingTable, setLoadingTable] = useState(false)
  const [dadosEstatisticas, setDadosEstatisticas] = useState([])
  const [dadosResultado, setDadosResultado] = useState([])
  const [codPro, setCodPro] = useState<number>(0)
  const [nomePropriedade, setNomePropriedade] = useState('')
  const [getVisibleDesenhaTalalhao, setVisibleDesenhaTalalhao] = useState(false)
  const [updateTalhao, setUpdateTalhao] = useState(0)

  //TABELA
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [total, setTotal] = useState(null)
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)
  const [buscarTabela, setBuscarTabela] = useState<string>('')
  const [propriedade, setPropriedade] = useState<string>('')

  //FORMULARIO
  const [open, setOpen] = useState(false)
  const [kmls, setKml] = useState<TalhaoItens>()
  const [selectedFile, setSelectedFile] = useState(null)
  const [nome, setNome] = useState<string>('')
  const [area, setArea] = useState<string>('')
  const [atualizar, setAtualizar] = useState(false)
  const [loadingSalvar, setLoadingSalvar] = useState(false)
  const [editPolygon, setEditPolygon] = useState<TypeEditPolygon>({
    polygon: [],
  } as TypeEditPolygon)
  const [editNovoPolygon, setEditNovoPolygon] = useState<TypeEditPolygon>({
    polygon: [],
  } as TypeEditPolygon)
  const [coordsKml, setCoordsKml] = useState([])

  //IMPORTAR KML
  const [visibleImportTalhao, setVisibleImportTalhao] = useState(false)
  const [propsMap, setPropsMapa] = useState<TypesMapa>({
    zoom: 2,
    center: {
      lat: 0,
      lng: 0,
    },
    mapContainerStyle: { width: '100%', height: '78vh' },
  })
  const [nameTalhao, setNameTalhao] = useState('')
  const [polygonTalhao, setPolygonTalhao] = useState([])
  const [dataPolygon, setDataPolygon] = useState<TypeDataTalhao[]>([])

  const listarPropriedades = async () => {
    setLoadingTable(true)
    const response = await getPropriedade('')
    const dados = response.data.itens
    setDataPropriedade(dados)
    if (dados.length === 1) {
      setCodPro(dados[0].cod)

      listTalhao(dados[0].cod)
    } else {
      setCodPro(null)
    }
    setLoadingTable(false)
  }

  const listTalhao = async (data) => {
    setLoadingTable(true)
    const response = await getTalhao(data, '', page, pagination)
    const resultado = response.data.itens.reduce(
      (soma, item) => {
        //@ts-ignore
        return {
          //@ts-ignore

          area: soma.area + parseFloat(item.area),
        }
      },
      {
        area: 0,
      }
    )

    const resultadoFinal = [
      {
        totalizado_area: formatarValor(resultado?.area),
      },
    ]

    gerarTabela(response.data.itens)
    gerarTabela2(resultadoFinal, response.data.itens.length)
    setDataTalhao(response?.data.itens)
    setLoadingTable(false)
    setCodPro(data ? data : 0)
    setNomePropriedade(response.data.itens[0]?.propriedade_nome)
    setTotal(response.data.total)
  }

  function gerarTabela(dados) {
    const data = dados?.map((item) => {
      return [
        { text: item?.nome, fontSize: 7, margin: [0, 2, 0, 2], alignment: 'center' },

        {
          text: formatarValor(item?.area),
          fontSize: 7,
          margin: [0, 2, 0, 2],
          alignment: 'center',
        },
      ]
    })

    const table = [
      {
        table: {
          headerRows: 1,
          widths: ['*', '*'],
          body: [
            [
              { text: 'Talhão', style: 'tableHeader', fontSize: 9, alignment: 'center' },
              { text: 'Área/ha', style: 'tableHeader', fontSize: 9, alignment: 'center' },
            ],
            ...data,
          ],
        },
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return rowIndex % 2 === 0 ? '#f5f5f5' : null
          },
        },
      },
    ]
    setDadosEstatisticas(table)
  }

  function gerarTabela2(dados, length) {
    const data = dados?.map((item) => {
      return [
        { text: length, fontSize: 7, margin: [0, 2, 0, 2], alignment: 'center' },
        { text: item?.totalizado_area, fontSize: 7, margin: [0, 2, 0, 2], alignment: 'center' },
      ]
    })

    const table = [
      {
        table: {
          headerRows: 1,
          widths: ['*', '*'], // Definindo larguras das colunas
          body: [
            [
              {
                text: 'Total de talhões',
                style: 'tableHeader',
                fontSize: 9,
                alignment: 'center',
              },
              { text: 'Total de Área', style: 'tableHeader', fontSize: 9, alignment: 'center' },
            ],
            ...data,
          ],
          margin: [0, 50, 0, 0],
        },
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return rowIndex % 2 === 0 ? '#f5f5f5' : null
          },
        },
      },
    ]
    setDadosResultado(table)
  }

  function abrirGaveta() {
    setOpen(true)
  }

  function editarCadastro(cod) {
    setOpen(true)
    setUpdateTalhao(cod)
  }

  const handleClickDesenhaTalhao = () => {
    setUpdateTalhao(0)
    setVisibleDesenhaTalalhao(true)
  }

  function fecharGaveta() {
    listTalhao(codPro)
    setUpdateTalhao(null)
    setCoordsKml([])
    setEditPolygon({
      nome: '',
      propriedadeCod: 0,
      propriedadeNome: 'string',
      fitBounds: null,
      polygon: [],
    })
    setEditNovoPolygon({
      nome: '',
      propriedadeCod: 0,
      propriedadeNome: 'string',
      fitBounds: null,
      polygon: [],
    })
    setOpen(false)
    setNome('')
    setArea('')
    setDataPolygon([])
    setSelectedFile(null)
    setKml(null)
  }

  const handleCloseModal = () => {
    setVisibleDesenhaTalalhao(false)
    listTalhao(codPro)
  }

  const handleClikBaixarKml = async (arquivo, nome, data) => {
    const response = await getKmlTalhao(data, arquivo)

    const blob = new Blob([response.data], {
      type: 'application/octet-stream',
    })
    url.current.href = URL.createObjectURL(blob)
    url.current.download = `${nome}.kml`
    url.current.click()
  }

  const handleTrashTalhao = async (codTalhao) => {
    setFake_loading(true)
    try {
      const responseDel = await delTalhao(codPro, codTalhao)

      if (responseDel.status === 200) {
        successAlert('Talhao excluído com sucesso!')
        setTimeout(() => {
          setFake_loading(false)
        }, 3600)
        listTalhao(codPro)
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response

        errorAlert(data?.error ?? 'Falha na operação')
      }
    }
  }

  const onFinish = async () => {
    loadingAlert({ msg: 'Salvando...', id: 'save_talhao' })
    setLoadingSalvar(true)
    const novoArquivo = selectedFile
    const dados = {
      nome: nome,
      cod_propriedade: codPro,
      arquivo: novoArquivo,
      status: 1,
      area: String(area),
    }
    try {
      if (updateTalhao <= 0) {
        const response = await postTalhao(codPro, dados)
        if (response.status === 201) {
          successAlert('Talhão cadastrado com sucesso!', 5000, 'save_talhao')
          listTalhao(codPro)
          fecharGaveta()
          setLoadingSalvar(false)
        }
      } else {
        const novoArquivo = selectedFile

        const dadosAtualizados = {
          ...dados,
          arquivo: novoArquivo,
        }
        const response = await putTalhao(codPro, updateTalhao, dadosAtualizados)

        if (response.status === 200) {
          successAlert('Talhão atualizado com sucesso!', 5000, 'save_talhao')
          fecharGaveta()
          setAtualizar(true)
          setLoadingSalvar(false)
        }
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response
        if (!data.error[0].field) {
          errorAlert(data?.error ?? 'Falha na operação!', 7000, 'save_talhao')
          setAtualizar(false)
          setLoadingSalvar(false)
        } else {
          data.error.forEach((data) => {
            errorAlert(data?.msg?.[0] ?? 'Falha na operação!', 7000, 'save_talhao')
          })
          setAtualizar(false)
          setLoadingSalvar(false)
        }
      } else {
        errorAlert('Falha na operação! (sem resposta)', 7000, 'save_ativos')
        setAtualizar(false)
        setLoadingSalvar(false)
      }
    }
  }

  useEffect(() => {
    listarPropriedades()
  }, [])

  useEffect(() => {
    listTalhao(codPro)
  }, [pagination])

  useEffect(() => {
    listTalhao(codPro)
  }, [page])

  // useEffect(() => {
  //     const idDaSafra = checkSafra('/talhao/cadastro')
  
  //     if (!idDaSafra) {
  //       history.push('/home')
  //     }
  //     console.log('OS SAFRA', idDaSafra)
  //   }, [])

  return (
    <ContainerTalhao>
      <ViewPage
        title='Talhões da propriedade'
        btnClick={null}
        newHide
        rotina={28}
        onPermission={setPermissions}
        hiddeTitle
        cardBodyStyle={{ padding: 15 }}
        cardMainStyle={{ height: '87.5vh' }}
      >
        <div>
          <TitleH1>Talhões da propriedade  </TitleH1>
        </div>

        <TabelaTalhoesPropriedade
          loading={loadingTable}
          setPagination={setPagination}
          page={page}
          setPage={setPage}
          total={total}
          update={codPro}
          listar_talhoes={dataTalhao}
          abrir={abrirGaveta}
          permissao={permissions}
          editarCadastro={editarCadastro}
          deletar={handleTrashTalhao}
          download={handleClikBaixarKml}
          confirmar_exclusao={confirmar_exclusao}
          setConfirmar_exclusao={setConfirmar_exclusao}
          id_item_atual={id_item_atual}
          setId_item_atual={setId_item_atual}
          nome_item_atual={nome_item_atual}
          setNome_item_atual={setNome_item_atual}
          fake_loading={fake_loading}
          setFake_loading={setFake_loading}
          buscarTabela={buscarTabela}
          setBuscarTabela={setBuscarTabela}
          listar_propriedades={dataPropriedade}
          desenhar={handleClickDesenhaTalhao}
          propriedade={propriedade}
          setPropriedade={setPropriedade}
          selecionar_propriedade={listTalhao}
          setDataPolygon={setDataPolygon}
          setNameTalhao={setNameTalhao}
          setPolygonTalhao={setPolygonTalhao}
          setPropsMapa={setPropsMapa}
          setVisibleImportTalhao={setVisibleImportTalhao}
          dadosEstatisticas={dadosEstatisticas}
          dadosResultado={dadosResultado}
          dataTalhao={dataTalhao}
          nomePropriedade={''}
        />
        <a style={{ display: 'none' }} href='empty' ref={url}>
          ref
        </a>
        <Drawer
          title={
            <NavegacaoDrawer>
              <ButtonCustom
                danger
                icon={<FontAwesomeIcon icon={faXmark} />}
                type='tertiary'
                onClick={() => fecharGaveta()}
                style={{ marginLeft: -10 }}
              >
                Fechar
              </ButtonCustom>
            </NavegacaoDrawer>
          }
          open={open}
          width={500}
          onClose={() => fecharGaveta()}
          closable={false}
          bodyStyle={{ padding: 0 }}
          headerStyle={{ padding: '10px 10px' }}
          footer={
            <div className='footer'>
              <ButtonCustom
                icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                type='primary'
                onClick={onFinish}
                disabled={loadingSalvar}
                loading={loadingSalvar}
              >
                Salvar
              </ButtonCustom>
            </div>
          }
          destroyOnClose
        >
          <FormTalhaoNovo
            loadingForm={false}
            update={updateTalhao}
            nome={nome}
            setNome={setNome}
            area={area}
            setArea={setArea}
            selectedFile={selectedFile}
            setSelectedFile={setSelectedFile}
            kmls={kmls}
            setKml={setKml}
            atualizar={atualizar}
            setAtualizar={setAtualizar}
            editPolygon={editPolygon}
            setEditPolygon={setEditPolygon}
            editNovoPolygon={editNovoPolygon}
            setEditNovoPolygon={setEditNovoPolygon}
            coordsKml={coordsKml}
            setCoordsKml={setCoordsKml}
            codPro={codPro}
          />
        </Drawer>
      </ViewPage>
      <Modal
        style={{ top: 20, minWidth: '95%', padding: '0px' }}
        open={getVisibleDesenhaTalalhao}
        onCancel={handleCloseModal}
        footer={false}
        closeIcon={false}
        bodyStyle={{ padding: 0 }}
        destroyOnClose
      >
        <div style={{ paddingBottom: '5px' }}>
          <ButtonCustom
            icon={<FontAwesomeIcon icon={faXmark} />}
            danger
            type='tertiary'
            onClick={handleCloseModal}
          >
            Fechar
          </ButtonCustom>
        </div>
        <DesenhaTalhaoNovo
          visible={getVisibleDesenhaTalalhao}
          onClose={handleCloseModal}
          update={updateTalhao}
          propriedade={codPro}
          atualizar={listTalhao}
          cultivavel={false}
        />
      </Modal>
      <Modal
        closeIcon
        style={{ top: 20, minWidth: '95%' }}
        open={visibleImportTalhao}
        destroyOnClose={visibleImportTalhao}
        okButtonProps={{ hidden: true }}
        cancelButtonProps={{ hidden: true }}
      >
        <ImporteKmlTalhao
          tituloPainel={'Importar talhões para a propriedade'}
          listTalhoesRecord={dataTalhao}
          mapSet={propsMap}
          propriedade={codPro}
          nameTalhao={nameTalhao}
          paths={polygonTalhao}
          dataPolygon={dataPolygon}
          onClose={() => {
            setVisibleImportTalhao(false)
            listTalhao(codPro)
          }}
        />
      </Modal>
    </ContainerTalhao>
  )
}

export default TalhaoNovo